<template>
  <section>
    <div id="parent" class="A3R">
      <!--
      <canvas id="print-canvas"
        style="position: absolute; margin:0; padding:0"
      ></canvas>
      -->
    </div>
  </section>
</template>

<script>
export default {
  components: {
  },
  props: {
    sourceImage: {
      type: HTMLImageElement ,
      require: true,
    },
    zoom: {
      type: Number,
      default: 1,
    },
    centerx: {
      type: Number,
      default: 0,
    },
    centery: {
      type: Number,
      default: 0,
    },
    paper: {
      type: String,
      default: 'A4',
    },
    descText: {
      type: Array,
      default: null,
    },
  },
  computed: {
    mmA3Width() {
      //return 409.63;
      return 404;
    },
    mmA3Height() {
      //return 286.65;
      return 270;
    },
    inchA3Width() {
      return this.mmA3Width / 10 / 2.54;
    },
    inchA3Height() {
      return this.mmA3Height / 10 / 2.54;
    },
    pixA3Width() {
      return this.inchA3Width * 300; //DPI取得困難なため決め打ち
    },
    pixA3Height() {
      return this.inchA3Height * 300; //DPI取得困難なため決め打ち
    },
  },
  mounted () {
    this.drawImage(this.sourceImage, this.centerx, this.centery);
  },
  watch:{
  },
  methods: {
    drawImage(image, cx, cy) {
      if (image) {
        //const canvas = document.getElementById('print-canvas');
        //const parent = canvas.parentElement;
        const canvas = document.createElement('canvas');
        const parent = document.getElementById('parent');
        canvas.style.margin = '0';
        canvas.style.padding = '0';
        parent.appendChild(canvas);
        canvas.width = this.pixA3Width;
        canvas.height = this.pixA3Height;
        const context = canvas.getContext('2d');
        const x = cx;
        const y = cy;
        const w = this.pixA3Width;
        const h = this.pixA3Height;
        //const scale = this.pixA3Width / parent.clientWidth;
        canvas.style.width = `${parent.clientWidth}px`;
        canvas.style.height =  `${parent.clientHeight}px`
        //context.scale(1/scale, 1/scale);
        context.drawImage(image, x, y, w, h, 0, 0, canvas.width, canvas.height);
      }
    }
  },  
}
</script>
<style lang="scss" scoped>
.A4 {
  //width: 210mm;
  //height: 296mm;
  width: 190mm;
  height: 276mm;
  //width: 172mm;
  //height: 251mm;
  page-break-after: auto;
  background-color: white;
}
.A4R {
  width: 296mm;
  height: 210mm;
  page-break-after: auto;
  background-color: white;
}
.A3 {
  width: 296mm;
  height: 420mm;
  page-break-after: auto;
  background-color: white;
}
.A3R {
  //width: 420mm;
  //height: 296mm;
  width: 404mm;
  //height: 276mm;
  height: 270mm;
  margin: 0mm;
  padding: 0mm;
  page-break-after: none;
  background-color: white;
}
@media print {
  @page {
    //size: A3 landscape !important;
    size: auto !important;
    margin: 0;
    background: none !important;
  }
  body {
    margin: 0mm;
    background: none !important;
  }
  main {
    margin: 0mm;
    background: none !important;
  }
}
</style>
